import { render, staticRenderFns } from "./DeliveryDetails.vue?vue&type=template&id=3793a24e&scoped=true"
import script from "./DeliveryDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryDetails.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDetails.vue?vue&type=style&index=0&id=3793a24e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3793a24e",
  null
  
)

export default component.exports